<s1-input-multiselect class="mb-2" [control]="control" [label]="label" [options]="options" (onFilterChange)="search($event)"></s1-input-multiselect>